import "core-js/modules/esnext.async-iterator.filter.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.async-iterator.for-each.js";
import "core-js/modules/esnext.iterator.for-each.js";
import _defineProperty from "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.27.4_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_7cca35337dd8404c2bdaa7eb9a6410df/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/esnext.async-iterator.find.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMediaQuery as useMediaQuery_ } from "@react-hookz/web";
import { removeAtMedia } from "scmp-sdk";
import { useWindow } from "shared/hooks";
import { theme } from "shared/lib/styles";
const useMediaQuery = (breakpointString, options) => useMediaQuery_(removeAtMedia(breakpointString), options);

/**
 *  Check current screen is fitting the breakpoint string or not
 *  @example useResponsive(theme.breakpoint.up("desktop"))
 */
export const useResponsive = function (breakpointString) {
  let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let options = arguments.length > 2 ? arguments[2] : undefined;
  const mediaValue = useMediaQuery(breakpointString, _objectSpread({
    initializeWithValue: false
  }, options));
  return mediaValue ?? defaultValue;
};
export const useBreakpoint = () => {
  const isLargeDesktopUp = useMediaQuery(theme.breakpoints.up("largeDesktop"), {
    initializeWithValue: false
  });
  const isMediumDesktop = useMediaQuery(theme.breakpoints.only("mediumDesktop"), {
    initializeWithValue: false
  });
  const isSmallDesktop = useMediaQuery(theme.breakpoints.between("desktop", "mediumDesktop"), {
    initializeWithValue: false
  });
  const isTablet = useMediaQuery(theme.breakpoints.only("tablet"), {
    initializeWithValue: false
  });
  const isMobile = useMediaQuery(theme.breakpoints.only("mobile"), {
    initializeWithValue: false
  });
  const window = useWindow();
  // When it's under ssr, return mobile
  if (window) return "mobile";
  const map = {
    desktop: isSmallDesktop,
    largeDesktopUp: isLargeDesktopUp,
    mediumDesktop: isMediumDesktop,
    mobile: isMobile,
    tablet: isTablet
  };
  return Object.keys(map).find(breakpoint => map[breakpoint]) ?? "mobile";
};